import { Component, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClientDataTableItem } from 'src/app/services/clients/clients.service';
import { CreditsService } from 'src/app/services/credits/credits.service';
import { CurrencyService } from 'src/app/services/currency/currency.service';
import { HelpersService } from 'src/app/services/helpers/helpers.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeDropdownComponent } from '../../../../shared/payee-form-fields/payee-dropdown/payee-dropdown.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-add-credits-dialog',
  templateUrl: './add-credits-dialog.component.html',
  styleUrls: ['./add-credits-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeDropdownComponent,
    PayeeButtonComponent,
    MatDialogClose,
    JsonPipe,
  ],
})
export class AddCreditsDialogComponent implements OnInit {
  private currencyService = inject(CurrencyService);
  private dialogRef =
    inject<
      MatDialogRef<AddCreditsDialogComponent, ClientDataTableItem | undefined>
    >(MatDialogRef);
  private snackbar = inject(MatSnackBar);
  private helpersService = inject(HelpersService);
  private creditsService = inject(CreditsService);

  readonly data = inject<ClientDataTableItem>(MAT_DIALOG_DATA);

  readonly form = new FormGroup({
    amount: new FormControl<number | null>(null, [
      Validators.required,
      Validators.min(1),
    ]),
    currency_iso: new FormControl('HUF', {
      validators: Validators.required,
      nonNullable: true,
    }),
  });

  loading = false;
  currencyOptions: string[] = [];

  get amount() {
    return this.form.controls.amount;
  }
  get currency_iso() {
    return this.form.controls.currency_iso;
  }

  async ngOnInit(): Promise<void> {
    try {
      this.currencyOptions = await this.currencyService.getCurrencies();
    } catch {
      this.dialogRef.close();
      this.snackbar.open('Hiba történt a pénznemek betöltése közben');
    }
  }

  async submit(): Promise<void> {
    if (this.loading || this.form.invalid) {
      this.helpersService.markAllChildrenAsDirty(this.form);
      return;
    }

    try {
      this.loading = true;

      const client = await this.creditsService.add(this.data.id, {
        amount: this.amount.value!,
        currency_iso: this.currency_iso.value,
      });
      this.dialogRef.close(client);
    } catch (error) {
      console.error('Error while adding credits', error);
      this.snackbar.open('Valami hiba történt');
    } finally {
      this.loading = false;
    }
  }
}
